import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import { createSelector } from "reselect";
// Actions
import {
  setView,
  errorResponse,
  setVirtualKeyboard,
  fetchParticipantStudies,
  setLocalFilepath,
  fetchLocalParticipantsList,
  fetchRemoteParticipantsList,
} from "../../actions";

// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import Box from "@material-ui/core/Box";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
//Icons
import FolderIcon from "@material-ui/icons/Folder";
import CloudIcon from "@material-ui/icons/Cloud";
import CloudDoneIcon from "@material-ui/icons/CloudDone";

// Other Files
import { colors } from "../../constants/colors";
import { remoteStatus, wifiEnabled } from "../../constants/constants";
import Header from "../Header/Header";
import SnackbarInfo from "../Shared/Snackbar";
import ParticipantDataTable from "./ParticipantDataTable";
import LoadParticipantReviewConflictDialog from "./LoadParticipantReviewConflictDialog";
import { customTheme } from "../../constants/customTheme";
import { CloudSync } from "../../constants/customIcons";
const useStyles = makeStyles({
  fill: {
    flex: "1 0 auto",
    backgroundColor: (props) => colors[props.theme].background,
  },
  cardRoot: (props) => ({
    ...customTheme(props.theme).card.root,
    padding: "0px",
    width: "calc(100% - 60px)",
    height: "calc(100% - 60px)",
    maxWidth: "calc(100% - 60px)",
    maxHeight: "calc(100% - 60px)",
    "@media only screen and (max-height: 600px)": {
      width: "calc(100% - 50px)",
      height: "calc(100% - 60px)",
      maxWidth: "calc(100% - 50px)",
      maxHeight: "calc(100% - 60px)",
    },
  }),
  copyright: customTheme().copyright,
  loadingStudy: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  centerText: {
    display: "flex",
    justifyContent: "center",
    marginTop: "100px",
    flexDirection: "column",
    alignItems: "center",
  },
  backdrop: {
    zIndex: 2,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
  backdropText: {
    width: "350px",
    paddingTop: "15px",
    textAlign: "center",
    fontSize: "1.2rem",
  },
  progressText: {
    width: "350px",
    paddingTop: "15px",
    textAlign: "center",
  },
  appBar: {
    backgroundColor: (props) => colors[props.theme].headerBkg,
    "& .MuiTabs-root": {
      height: "40px",
    },
  },
  tab: {
    flexBasis: "unset",
    flexShrink: "unset",
    minHeight: "unset",
    "& .MuiTab-wrapper": {
      ...customTheme().tabTitle,
      fontSize: "1.0rem",
      flexDirection: "unset",
      textTransform: "capitalize",
      "& .MuiSvgIcon-root": {
        marginRight: "10px",
        marginBottom: "0px",
      },
    },
  },
  icon: customTheme().icon,
  subDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "15px 0px 10px 20px",
  },
  localFolderpathText: {
    marginBottom: "10px",
  },
  fileIcon: (props) => customTheme(props.theme).iconButton,
  formText: customTheme().formText,
  buttonPrimary: (props) => customTheme(props.theme).buttonPrimary,

  progressCircle: {
    "& .MuiCircularProgress-static": {
      transition: "transform 0ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
    "& .MuiCircularProgress-circleStatic": {
      transition: "stroke-dashoffset 0ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  progressLabel: {
    fontSize: "0.9rem",
  },
  fabProgress: {
    top: "-5px",
    left: "-5px",
    zIndex: 1,
    position: "absolute",
  },
  cloudButtonWrap: {
    position: "relative",
    marginRight: "8px",
  },

  cloudButton: (props) => ({
    padding: "0px",
    width: "36px",
    height: "36px",
    backgroundColor:
      props.remoteParticipantsListReceived && props.showRemoteStudies
        ? colors[props.theme].primary
        : colors.secondaryText,

    "&:hover": {
      backgroundColor:
        props.remoteParticipantsListReceived && props.showRemoteStudies
          ? colors[props.theme].primaryLight
          : "#e0e0e0",
    },
  }),
  syncField: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
});

const LoadParticipantReview = (props) => {
  // Hook States
  const [tab, setTab] = React.useState("LOCAL");
  const [progressIndicator, setProgressIndicator] = React.useState({
    value: 0,
    message: null,
  }); // Circular progress value
  const [showRemoteStudies, setShowRemoteStudies] = React.useState(true);
  const [
    loadParticipantReviewConflictDialog,
    setLoadParticipantReviewConflictDialog,
  ] = React.useState({
    open: false,
    participantId: null,
    studyDetails: [],
    selectedStudyIds: [],
    cloudConflictStudies: [],
  });
  const classes = useStyles({ ...props, showRemoteStudies });
  // useEffect(() => {
  //   props.eventSource.addEventListener("progress_indicator", handleEvent);
  //   return () => {
  //     props.eventSource.removeEventListener("progress_indicator", handleEvent);
  //   };
  // }, []);

  const handleEvent = (e) => {
    switch (e.type) {
      case "progress_indicator":
        let data = JSON.parse(e.data);
        console.log(data);
        setProgressIndicator({
          value: data.value * 100,
          message: data.message,
        });
        break;
      default:
    }
  };

  const handleCloudButtonClick = () => {
    if (
      !props.remoteParticipantsListReceived &&
      !props.remoteParticipantsListFetching
    ) {
      props.fetchRemoteParticipantsList();
    } else {
      if (showRemoteStudies) {
        setShowRemoteStudies(false);
      } else {
        setShowRemoteStudies(true);
      }
    }
  };

  function handleClickRow(rowData) {
    setProgressIndicator({ value: 0, message: null });
    if (showRemoteStudies) {
      let cloudConflictStudies = [];
      for (let selectedStudyId of rowData.selectedStudyIds) {
        let selectedStudy = rowData.row.studyDetails.filter(
          (studyDetail) => studyDetail.id === selectedStudyId
        )[0];

        if (
          selectedStudy.studySource === "BOTH" &&
          ![remoteStatus.sync, remoteStatus.match].includes(
            selectedStudy.remoteCopy.status
          )
        ) {
          cloudConflictStudies.push(selectedStudyId);
        }
      }

      if (cloudConflictStudies.length !== 0) {
        setLoadParticipantReviewConflictDialog({
          ...loadParticipantReviewConflictDialog,
          open: true,
          participantId: rowData.row.participantId,
          studyDetails: rowData.row.studyDetails,
          selectedStudyIds: rowData.selectedStudyIds,
          cloudConflictStudies: cloudConflictStudies,
        });
      } else {
        handleGetStudies(
          rowData.row.participantId,
          rowData.row.studyDetails,
          rowData.selectedStudyIds
        );
      }
    } else {
      handleGetStudies(
        rowData.row.participantId,
        rowData.row.studyDetails,
        rowData.selectedStudyIds
      );
    }
  }

  function handleGetStudies(participantId, studyDetails, selectedStudyIds) {
    let localStudies = [];
    let remoteStudies = [];
    for (let selectedStudyId of selectedStudyIds) {
      let selectedStudy = studyDetails.filter(
        (studyDetail) => studyDetail.id === selectedStudyId
      )[0];
      if (
        (!showRemoteStudies && selectedStudy.studySource !== "REMOTE") ||
        selectedStudy.studySource === "LOCAL" ||
        (selectedStudy.studySource === "BOTH" &&
          selectedStudy.remoteCopy.status === remoteStatus.match)
      ) {
        localStudies.push(selectedStudy.id);
      } else if (
        selectedStudy.studySource === "REMOTE" ||
        (selectedStudy.studySource === "BOTH" &&
          selectedStudy.remoteCopy.status === remoteStatus.sync)
      ) {
        remoteStudies.push(selectedStudy.id);
      }
    }
    props.fetchParticipantStudies(participantId, localStudies, remoteStudies);
  }
  const handleLocalFilepathChange = (newLocalFilepath) => {
    props.setLocalFilepath(newLocalFilepath);
    props.fetchLocalParticipantsList();
  };

  const handleFileExplorer = () => {
    const { dialog } = window.require("electron").remote;
    const defaultPath = props.localFolderpath.split("/").join("\\");
    dialog.showOpenDialog(
      {
        defaultPath: defaultPath,
        properties: ["openDirectory"],
      },
      (filePaths) => {
        if (filePaths !== undefined && filePaths.length !== 0) {
          let newPath = filePaths[0].split("\\").join("/");
          handleLocalFilepathChange(newPath);
        }
      }
    );
  };
  return (
    <Grid
      item
      container
      className={classNames(classes.fill, "noselect")}
      direction="column"
    >
      {/* HEADER */}
      <Header
      // eventSource={props.eventSource}
      />

      <Grid
        item
        container
        className={classes.fill}
        direction="column"
        justify="space-between"
      >
        <Grid
          item
          container
          className={classes.fill}
          direction="column"
          justify="center"
          alignItems="center"
        >
          {/* INFORMATION */}
          <Card className={classes.cardRoot}>
            {/* <AppBar
              color="default"
              className={classes.appBar}
              position="static"
            >
              <Tabs
                value={tab}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                // onChange={handleChange}
              >
                <Tab
                  label="Local Folder"
                  value="LOCAL"
                  icon={<FolderIcon />}
                  className={classes.tab}
                />
              </Tabs>
            </AppBar> */}
            {tab === "LOCAL" &&
              /////// LOCAL FOLDER //////////
              (props.localParticipantsListFetching ? (
                <div className={classes.centerText}>
                  <CircularProgress size={35} />
                  <Typography className={classes.progressText}>
                    {progressIndicator.message !== null
                      ? progressIndicator.message
                      : "Loading participants..."}
                  </Typography>
                </div>
              ) : (
                <div>
                  <div className={classes.subDiv}>
                    <InputBase
                      className={classes.localFolderpathText}
                      value={props.localFolderpath}
                      fullWidth
                      multiline
                      rowsMax={2}
                      readOnly
                      startAdornment={
                        <Tooltip
                          placement="top"
                          title="Change Directory"
                          enterTouchDelay={300}
                          classes={{
                            tooltip: classes.tooltip,
                          }}
                        >
                          <InputAdornment position="start">
                            <IconButton
                              className={classes.fileIcon}
                              onClick={handleFileExplorer}
                              disabled={true}
                            >
                              <FolderIcon />
                            </IconButton>
                          </InputAdornment>
                        </Tooltip>
                      }
                      inputProps={{
                        className: classes.formText,
                      }}
                    />
                    {wifiEnabled && (
                      <div className={classes.syncField}>
                        <div className={classes.cloudButtonWrap}>
                          <Fab
                            className={classes.cloudButton}
                            disabled
                            onClick={() => handleCloudButtonClick()}
                          >
                            {props.remoteParticipantsListReceived ? (
                              <CloudDoneIcon />
                            ) : (
                              <CloudSync />
                            )}
                          </Fab>
                          {props.remoteParticipantsListFetching && (
                            <CircularProgress
                              size={45}
                              className={classes.fabProgress}
                            />
                          )}
                        </div>
                        <p className={classes.formText}>
                          Show participants on cloud
                        </p>
                      </div>
                    )}
                  </div>
                  <ParticipantDataTable
                    showRemoteStudies={showRemoteStudies}
                    handleClickRow={(rowData) => handleClickRow(rowData)}
                    data={props.participantsByIdTableData}
                  />
                </div>
              ))}
          </Card>
        </Grid>

        <Backdrop
          className={classes.backdrop}
          open={props.setParticipantStudiesFetching}
        >
          <div className={classes.loadingStudy}>
            {progressIndicator.value === 0 ? (
              <CircularProgress size={35} />
            ) : (
              <Box
                className={classes.progressCircle}
                position="relative"
                display="inline-flex"
              >
                <CircularProgress
                  variant="static"
                  value={progressIndicator.value}
                  className={classes.circle}
                  size={50}
                />
                <Box
                  top={0}
                  left={0}
                  bottom={0}
                  right={0}
                  position="absolute"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography
                    className={classes.progressLabel}
                    variant="caption"
                    component="div"
                  >{`${Math.round(progressIndicator.value)}%`}</Typography>
                </Box>
              </Box>
            )}
            <Typography className={classes.backdropText}>
              {progressIndicator.message !== null
                ? progressIndicator.message
                : "Loading participant's studies..."}
            </Typography>
          </div>
        </Backdrop>
        {loadParticipantReviewConflictDialog.open && (
          <LoadParticipantReviewConflictDialog
            onClose={() =>
              setLoadParticipantReviewConflictDialog({
                ...loadParticipantReviewConflictDialog,
                open: false,
              })
            }
            open={loadParticipantReviewConflictDialog.open}
            selectedStudyIds={
              loadParticipantReviewConflictDialog.selectedStudyIds
            }
            cloudConflictStudies={
              loadParticipantReviewConflictDialog.cloudConflictStudies
            }
            studyDetails={loadParticipantReviewConflictDialog.studyDetails}
            participantId={loadParticipantReviewConflictDialog.participantId}
            handleGetStudies={(participantId, studyDetails, selectedStudyIds) =>
              handleGetStudies(participantId, studyDetails, selectedStudyIds)
            }
            theme={props.theme}
          />
        )}
        {/* COPYRIGHT INFO */}
        <Grid item align="center" className={classes.copyright}>
          <Typography variant="caption" gutterBottom>
            This software is for investigational research use only. It is
            provided as-is with no warranty. &copy;{new Date().getFullYear()}{" "}
            MicroElastic Ultrasound Systems
          </Typography>
        </Grid>
      </Grid>

      {/* SNACKBAR FOR MESSAGE DISPLAY */}
      <SnackbarInfo />
    </Grid>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setView,
      errorResponse,
      setVirtualKeyboard,
      fetchParticipantStudies,
      setLocalFilepath,
      fetchLocalParticipantsList,
      fetchRemoteParticipantsList,
    },
    dispatch
  );
};

const reshapeParticipants = createSelector(
  [
    (state) => state.availableParticipants.localParticipantsById,
    (state) => state.availableParticipants.remoteParticipantsById,
  ],
  (localParticipantsById, remoteParticipantsById) => {
    let reshapeParticipantsInfo = Object.keys(localParticipantsById).map(
      (participantId) => {
        let localParticipantData = localParticipantsById[participantId];
        let studyDetails = [];

        Object.keys(localParticipantData.studyById).forEach((studyId) => {
          let study = localParticipantData.studyById[studyId];
          studyDetails.push({
            id: study.id,
            protocolName: study.protocolName,
            username: study.username,
            progress: study.progress === null ? "NA" : study.progress + "%",
            studyDate: study.studyDate,
            studySource: "LOCAL",
            studyHash: study.studyHash ? study.studyHash : [],
            study_filepath: study.study_filepath,
          });
        });

        // If participant exits in remote storage, then add the study data in remote storage
        if (Object.keys(remoteParticipantsById).includes(participantId)) {
          let remoteParticipantData = remoteParticipantsById[participantId];
          Object.keys(remoteParticipantData.studyById).forEach((studyId) => {
            let study = remoteParticipantData.studyById[studyId];
            if (
              !Object.keys(localParticipantData.studyById).includes(studyId)
            ) {
              studyDetails.push({
                id: study.id,
                protocolName: study.protocolName,
                username: study.username,
                progress: study.progress === null ? "NA" : study.progress + "%",
                studyDate: study.studyDate,
                studySource: "REMOTE",
                studyHash: study.studyHash ? study.studyHash : [],
              });
            } else {
              // Study has remote and local copy
              let foundIndex = studyDetails.findIndex(
                (localStudy) => localStudy.id === studyId
              );
              let status;
              if (
                studyDetails[foundIndex].studyHash &&
                study.studyHash &&
                studyDetails[foundIndex].studyHash.length !== 0 &&
                study.studyHash.length !== 0
              ) {
                let remoteHash = study.studyHash.map((hash) => {
                  return Object.keys(hash)[0];
                });
                let localHash = studyDetails[foundIndex].studyHash.map(
                  (hash) => {
                    return Object.keys(hash)[0];
                  }
                );

                if (remoteHash[0] === localHash[0]) {
                  status = remoteStatus.match;
                } else if (localHash.includes(remoteHash[0])) {
                  status = remoteStatus.localVersion;
                } else if (remoteHash.includes(localHash[0])) {
                  status = remoteStatus.remoteVersion;
                } else {
                  status = remoteStatus.divergent;
                }
              } else {
                status = remoteStatus.divergent;
              }

              studyDetails[foundIndex] = {
                ...studyDetails[foundIndex],
                studySource: "BOTH",
                remoteCopy: {
                  id: study.id,
                  protocolName: study.protocolName,
                  username: study.username,
                  progress:
                    study.progress === null ? "NA" : study.progress + "%",
                  studyDate: study.studyDate,
                  studySource: "REMOTE",
                  status: status,
                  studyHash: study.studyHash ? study.studyHash : [],
                },
              };
            }
          });
        }

        let latestStudy = studyDetails.sort((a, b) => {
          let bDate = Number(
            [
              b.studyDate.split("/")[2],
              b.studyDate.split("/")[1],
              b.studyDate.split("/")[0],
            ].join("")
          );
          let aDate = Number(
            [
              a.studyDate.split("/")[2],
              a.studyDate.split("/")[1],
              a.studyDate.split("/")[0],
            ].join("")
          );
          return bDate - aDate;
        })[0];

        return {
          participantId: participantId,
          otherId:
            localParticipantData.participantInfo.otherId === ""
              ? "-"
              : localParticipantData.participantInfo.otherId,
          numberOfStudies: studyDetails.length,
          dateOfLastStudy: latestStudy.studyDate,
          studyDetails: studyDetails,
          allRemote: false,
        };
      }
    );

    Object.keys(remoteParticipantsById).forEach((participantId) => {
      if (!Object.keys(localParticipantsById).includes(participantId)) {
        let remoteParticipantData = remoteParticipantsById[participantId];
        let studyDetails = [];

        Object.keys(remoteParticipantData.studyById).forEach((studyId) => {
          let study = remoteParticipantData.studyById[studyId];
          studyDetails.push({
            id: study.id,
            protocolName: study.protocolName,
            username: study.username,
            progress: study.progress === null ? "NA" : study.progress + "%",
            studyDate: study.studyDate,
            studyHash: study.studyHash ? study.studyHash : [],
            status: remoteStatus.sync,
            studySource: "REMOTE",
          });
        });

        let latestStudy = studyDetails.sort((a, b) => {
          return (
            Number(b.studyDate.replace(/\//g, "")) -
            Number(a.studyDate.replace(/\//g, ""))
          );
        })[0];

        reshapeParticipantsInfo.push({
          participantId: participantId,
          otherId:
            remoteParticipantData.participantInfo.otherId === "" ||
            typeof remoteParticipantData.participantInfo.otherId === "undefined"
              ? "-"
              : remoteParticipantData.participantInfo.otherId,
          numberOfStudies: studyDetails.length,
          dateOfLastStudy: latestStudy.studyDate,
          studyDetails: studyDetails,
          allRemote: true,
        });
      }
    });

    return reshapeParticipantsInfo;
  }
);

const mapStateToProps = (state) => {
  return {
    localFolderpath: state.availableStudies.localFolderpath,
    setParticipantStudiesFetching:
      state.availableParticipants.setParticipantStudiesFetching,
    participantsByIdTableData: reshapeParticipants(state),
    localParticipantsListFetching:
      state.availableParticipants.localParticipantsListFetching,
    remoteParticipantsListFetching:
      state.availableParticipants.remoteParticipantsListFetching,
    remoteParticipantsListReceived:
      state.availableParticipants.remoteParticipantsListReceived,
    availableParticipantsReceived:
      state.availableParticipants.availableParticipantsReceived,
    theme: state.utility.theme,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadParticipantReview);
